import { lazy } from "react";
import { ElementDetails, UserSocial } from "@/lib/types";
import { GoogleWorkspaceUsersProps } from "./types";

export const details = {
  name: "GoogleWorkspaceUsers",
  description: "Displays a list of users in the workspace with a search bar",
  tags: ["Business", "Organization"],
  category: "Google",
  grid: {
    medium: [3, 3],
    large: [4, 4],
  },
  gridNames: {
    medium: "Medium",
    large: "Large",
  },
  app: lazy(() => import("./App").then(m => ({ default: m.App }))),
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  integrationsUsed: ["google"],
  integrationScopes: { google: ["directory"] },
  userSocialPredicate: (social: UserSocial) =>
    social.provider === "google" && !social.email.endsWith("@gmail.com"),
  defaultProps: {
    showLastLoginTime: false,
  },
} as ElementDetails<GoogleWorkspaceUsersProps>;
